import { Modal, ModalBody } from 'react-bootstrap';
import warning from '../assets/images/warning.png';

const DelectModalComponent = ({ show, hideModal, deleteChanges }) => {
    return (
        <Modal show={show} className="modalPosition">
            <div className="modal-content" style={{ width: '100%' }}>
                <Modal.Header onClick={hideModal} closeButton>
                    <Modal.Title>Inactivate Confirmation</Modal.Title>
                </Modal.Header>
                <ModalBody >
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-sm-1 col-md-1 col-lg-1 col-xs-1">
                            <img name="warning" src={warning} style={{ width: '45px', height: '33px' }} id="warning" alt="" />
                            </div>
                            <div className="col-sm-1 col-md-1 col-lg-1 col-xs-1"></div>
                            <div className="col-sm-9 col-md-9 col-lg-9 col-xs-9 mt5">
                                <span className="fnt-size">Do you want to inactivate?</span>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer" style={{ padding: '0px', borderTop: '0px' }}>
                        <button className="btn btn-primary  " style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} onClick={deleteChanges}  >Yes</button>
                        <button className="btn  btn-primary  " style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} onClick={hideModal}  >No</button>
                    </div>
                </ModalBody>
            </div>
        </Modal>
    )
}

export default DelectModalComponent;